module.exports = __webpack_public_path__ + "img/cat-snacks.22aca9ec.webp";